const sliders = document.querySelectorAll<HTMLElement>('.post-slider');

sliders.forEach((slider) => {
	const swiperContainer = slider.closest('.block-post-slider');
	const nextButton = swiperContainer?.querySelector('.slider-pagination__button--next');
	const prevButton = swiperContainer?.querySelector('.slider-pagination__button--prev');

	new (window as Window).Swiper(slider, {
		slidesPerView: 1.1,
		spaceBetween: 16,
		pagination: {
			el: slider.querySelector('.post-slider__pagination'),
			clickable: true,
		},
		navigation: {
			nextEl: nextButton,
			prevEl: prevButton,
			disabledClass: 'slider-pagination__button--disabled',
		},
		breakpoints: {
			[window.impBreakpoints?.md ?? 768]: {
				slidesPerView: 2.1,
				spaceBetween: 24,
			},
			[window.impBreakpoints?.lg ?? 992]: {
				slidesPerView: 3.1,
			},
			[window.impBreakpoints?.xxl ?? 1304]: {
				slidesPerView: 3,
			},
		},
	});
});
